// core/services/firebase/config.ts - Configuração Firebase Multi-Tenant

import { initializeApp, FirebaseApp } from 'firebase/app';
import { getFirestore, Firestore } from 'firebase/firestore';
import { getAuth, Auth } from 'firebase/auth';
import { getStorage, FirebaseStorage } from 'firebase/storage';
import { getFunctions, Functions } from 'firebase/functions';

// Configuração principal do Firebase (use suas credenciais reais)
// Configuração principal do Firebase
const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY || "AIzaSyCMMWNBzFpKDZPtd3JXqaLCE0oAAbpBIww",
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || "app-pescar.firebaseapp.com",
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || "app-pescar",
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || "app-pescar.firebasestorage.app",
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || "271208644836",
  appId: import.meta.env.VITE_FIREBASE_APP_ID || "1:271208644836:web:5eece57c8731631b9eacf1",
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID || "G-0PTY5S2PDM"
};

// Inicializar Firebase
export const app: FirebaseApp = initializeApp(firebaseConfig);
export const db: Firestore = getFirestore(app);
export const auth: Auth = getAuth(app);
export const storage: FirebaseStorage = getStorage(app);
export const functions: Functions = getFunctions(app);

// App Check (Proteção contra bots e clones)
import { initializeAppCheck, ReCaptchaEnterpriseProvider } from 'firebase/app-check';

if (import.meta.env.PROD) {
  initializeAppCheck(app, {
    provider: new ReCaptchaEnterpriseProvider(import.meta.env.VITE_RECAPTCHA_SITE_KEY || '6Ld-mock-key-for-dev'),
    isTokenAutoRefreshEnabled: true
  });
}

// Analytics (condicional para evitar erros em SSR ou ambientes sem window, se aplicável, mas aqui é SPA)
import { getAnalytics, Analytics } from 'firebase/analytics';
export const analytics: Analytics = getAnalytics(app);

// Export default para compatibilidade
export default app;
